import axios from 'axios';

const apiStorage = axios.create({
  baseURL: process.env.REACT_APP_ORACLE_URL_UPLOAD,
});

export default apiStorage;
